import Vue from 'vue'
import { validata, validator } from './validata'
import isEmpty from 'is-empty'

Vue.prototype.$validata = validata
Vue.prototype.$validator = validator
Vue.prototype.$isEmpty = isEmpty
Vue.prototype.imgUrl = '//widenteen-os.widenteen.com'
